module.exports = __webpack_public_path__ + "img/yuans.4e3bf5a0.jpg";